export default __webpack_public_path__ + "static/media/pokedex4.7691a0ac.jpg";